// Vanilla Calendar Pro Init
// https://github.com/uvarov-frontend/vanilla-calendar-pro

(function (window) {
  'use strict';

  function initCalendars() {
    document.querySelectorAll('[data-calendar]').forEach(function (calendar) {
      const calendarOptions = {
        firstWeekday: 0,
        locale: window.ProjectEnv.calendar.locale,
        dateMin: window.ProjectEnv.calendar.dateMin,
        dateMax: window.ProjectEnv.calendar.dateMax,
        popups: window.ProjectEnv.calendar.popups,
        layouts: {
          default: `
            <div class="vc-header">
            <div class="vc-header__content">
              <#Month />
              <#Year />
            </div>
              <#ArrowPrev />
              <#ArrowNext />
            </div>
            <div class="vc-wrapper">
              <#WeekNumbers />
              <div class="vc-content">
                <#Week />
                <#Dates />
              </div>
            </div>
            <#ControlTime />
          `,
        },
      };

      const { Calendar } = window.VanillaCalendarPro;
      const eventCalendar = new Calendar(calendar, calendarOptions);
      const calendarIsVisible = new IntersectionObserver((currentCalendar) => {
        if (window.innerWidth < 900) {
          eventCalendar.update();
        }
      });

      eventCalendar.init();
      calendarIsVisible.observe(calendar);
    });
  }

  initCalendars();
})(this);
